import { Form } from 'factorial-form'

class IncidenceMessageForm extends Form {
  constructor(values: {}) {
    super(values, {
      message: 'string',
      incidence_id: 'string',
      bookkeeper_view: 'boolean',
      type: 'string',
      company_id: 'string',
    })
  }
}

export default IncidenceMessageForm
